__turbopack_context__.v({
  "divider": "company-section-title-module__zl2-BW__divider",
  "title": "company-section-title-module__zl2-BW__title",
  "titleSection": "company-section-title-module__zl2-BW__titleSection",
});
